import { Box } from "@chakra-ui/react";
import { Tabs as BarteTabs } from "barte-design-system";

interface TabItem {
    key: string;
    label: string;
    content: React.ReactNode;
}

interface TabsProps {
    tabs: TabItem[];
    onChange?: (key: string) => void;
    currentKey?: string;
}

export const Tabs = ({ tabs, onChange, currentKey }: TabsProps) => {
    const activeTab = tabs.find((tab) => tab.key === currentKey) ?? tabs[0];

    return (
        <>
            <BarteTabs>
                {tabs.map(({ key, label }) => (
                    <BarteTabs.Tab 
                        key={key} 
                        value={key} 
                        active={key === currentKey}
                        onClick={() => onChange?.(key)}
                    >
                        {label}
                    </BarteTabs.Tab>
                ))}
            </BarteTabs>

            <Box >
                {activeTab?.content}
            </Box>
        </>
    );
};
